import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './MfaPage.module.css';
import MfaAuthSelectPanel from './panel/mfa/MfaAuthSelectPanel';
import MfaOtpVerifyPanel from './panel/mfa/MfaOtpVerifyPanel';
import MfaEmailVerifyPanel from './panel/mfa/MfaEmailVerifyPanel';
// import MfaPasskeyVerifyPanel from './panel/mfa/MfaPasskeyVerifyPanel';
import MfaSuccessPanel from './panel/mfa/MfaSuccessPanel';
// import MfaFailPanel from './panel/mfa/MfaFailPanel'; 
import { AuthContext } from "../../utils/contextapi/AuthProvider";
import { CLIENT_ID, CLIENT_SECRET, IAM_PATH, NONCE, OAUTH, OAUTH_AUTHORIZE, OAUTH_TOKEN, REDIRECT_URI, RESPONSE_TYPE, SCOPE, STATE } from "../../utils/Config";
import axios from "../../utils/api/axios";
import MfaPasskeyVerifyPanel from './panel/mfa/MfaPasskeyVerifyPanel';
import { setCookie } from '../../utils/cookies/cookies';
import { InnocodeButton } from '@intsoft/innocode-core';

function MfaPage() {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const location = useLocation();
    const inviteState = location.state;

    const { saveToken, saveAuthenticated, saveRefreshToken, saveTokenExpiresIn, saveRole, saveUser, doLogout } = useContext(AuthContext);

    const [emailToken, setEmailToken] = useState('');

    const [userData, setUserData] = useState({
        id: inviteState?.id || '', // inviteState가 항상 있지만, 혹시 모를 대비
        pw: inviteState?.pw || '',
        loginType: inviteState?.loginType || 'login',
        loginToken: inviteState?.loginToken || ''
    });

    const isLogin = !!inviteState?.id;

    // useEffect(() => {

    //   if (isLogin) {
    //     setUserData(prev => ({
    //       ...prev,
    //       id: inviteState.id,
    //       pw: inviteState.pw,
    //       loginType: inviteState.loginType
    //     }));

    //   }
    // }, [isLogin, inviteState]);

    const handleComplete = () => {
        navigate('/login');
    };

    const goBack = () => {
        if (step === 1) {
            navigate('/login');
        } else if (step === 2) {
            setStep(1);
        } else if (step === 3) {
            setStep(1);
        } else if (step === 4) {
            setStep(1);
        } else {
            setStep(step - 1);
        }
    };

    // MFA 성공 핸들러
    const handleMfaSuccess = async () => {
        await login();
        setStep(6); // 인증 완료 페이지로 이동
    }

    // MFA 실패 핸들러
    const handleMfaFail = () => {
        setStep(7); // 인증 실패 페이지로 이동
    }

    async function getPublicIp() {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return data.ip;
        } catch (error) {
            console.error('Failed to get public IP:', error);
            return null;
        }
    }

    const login = async () => {
        sessionStorage.clear();
        doLogout();
        const publicIp = await getPublicIp();
        const data = { unifiedProfileId: userData.id, password: userData.pw, type: userData.loginType }
        // await axios.post(IAM_PATH + "/login", data, { withCredentials: true })
        //     .then(async response => {
        // const loginToken = response.data.data.login_token;
        const authorizeConfig = {
            response_type: RESPONSE_TYPE,
            client_id: CLIENT_ID,
            redirect_uri: REDIRECT_URI,
            scope: SCOPE,
            state: STATE,
            nonce: NONCE,
            clientIp: publicIp
        };
        const authorizeQueryString = new URLSearchParams(authorizeConfig).toString();

        await axios.get(`${OAUTH_AUTHORIZE}?${authorizeQueryString}`, {
            headers: {
                Authorization: `Bearer ${userData.loginToken}` // 일반적으로 login_token은 Authorization 헤더에 담음
            },
            withCredentials: true // 필요한 경우 true
        })
            .then(async response => {
                const authorization_code = response.data.code;
                const tokenConfig = {
                    grant_type: "authorization_code",
                    code: authorization_code,
                    client_id: CLIENT_ID,
                    client_secret: CLIENT_SECRET,
                    redirect_uri: REDIRECT_URI,
                    scope: SCOPE,
                    state: STATE,
                    code_verifier: NONCE,
                };
                const tokenQueryString = new URLSearchParams(tokenConfig).toString();

                await axios.post(`${OAUTH_TOKEN}?${tokenQueryString}`, null, { withCredentials: true })
                    .then(async response => {

                        const { access_token, expires_in, id_token, refresh_token, exp_timestamp, refresh_token_expires_in } = response.data;

                        let finalExpiresIn;
                        if (exp_timestamp) {
                            // 서버에서 정확한 타임스탬프를 줬으므로 그대로 사용 (밀리초 단위로 가정)
                            finalExpiresIn = exp_timestamp;
                        } else {
                            // 혹시 서버에서 주지 않는 경우를 위한 fallback (기존 방식)
                            finalExpiresIn = Date.now() + (expires_in * 1000);
                        }

                        saveTokenExpiresIn(finalExpiresIn);
                        saveToken(access_token, finalExpiresIn);
                        saveRefreshToken(refresh_token, refresh_token_expires_in);
                        saveAuthenticated(true);

                        // 크롬이 완전히 닫혔다가 열렸을 경우, 해당 값을 토대로 재로그인 기능 구현.
                        // sessionStorage.setItem("access_token", access_token);
                        // sessionStorage.setItem("refresh_token", refresh_token);
                        // sessionStorage.setItem("tokenExpiresIn", finalExpiresIn);
                        setCookie("user_id", userData.id, finalExpiresIn);

                        await axios.get(OAUTH + "/userinfo")
                            .then(async userRes => {
                                const { data } = userRes;
                                // roles가 배열이면 그대로, 아니면 배열로 변환
                                const roles = Array.isArray(data.roles) ? data.roles.filter(Boolean) : [];

                                saveRole(roles.length > 0 ? roles : ["USER"], finalExpiresIn); // context에 저장
                                saveUser(data, finalExpiresIn);
                                // sessionStorage.setItem("roles", JSON.stringify(roles));
                                // sessionStorage.setItem("user", JSON.stringify(data));
                                // saveAuthenticated(true);

                                // navigate('/account/manage');
                            })
                    })
                    .catch(error => {
                        console.error('OAUTH_TOKEN', error);
                    });
            })
            .catch(error => {
                console.error('OAUTH_AUTHORIZE', error);
            });
        // })
        // .catch(error => {
        //     console.error(error);
        // });
    }


    const renderStep = () => {
        switch (step) {
            case 1:
                return (
                    <MfaAuthSelectPanel
                        onSelectOtp={() => setStep(2)}
                        onSelectEmail={() => setStep(3)}
                        onSelectPasskey={() => setStep(4)}
                        userId={userData.id}
                    />
                );
            case 2:
                return (
                    <MfaOtpVerifyPanel
                        onSuccess={handleMfaSuccess}
                        onBack={() => setStep(1)}
                        userId={userData.id}
                    />
                );
            case 3:
                return (
                    <MfaEmailVerifyPanel
                        onSuccess={handleMfaSuccess}
                        onBack={() => setStep(1)}
                        userId={userData.id}
                    />
                );
            case 4:
                return (
                    <MfaPasskeyVerifyPanel
                        onSuccess={handleMfaSuccess}
                        onFail={handleMfaFail}
                        onBack={goBack}
                        userId={userData.id}
                    />
                );
            // case 5:
            //     return (
            //         <MfaPasskeyVerifyPanel
            //             onSuccess={handleMfaSuccess}
            //             onFail={handleMfaFail}
            //             onBack={goBack}
            //             userId={userData.id}
            //         />
            //     );
            case 6:
                return <MfaSuccessPanel onNext={() => {
                    console.log("onNext success!!!");
                    if (inviteState?.tenantId && inviteState?.email) {
                        navigate('/login', {
                            replace: true,
                            state: {
                                email: inviteState.email,
                                tenantId: inviteState.tenantId,
                                inviter: inviteState.inviter,
                            },
                        });
                        return;
                    }
                    navigate('/account/manage');
                }} />;
            // case 7:
            // return <MfaFailPanel onBack={() => setStep(1)} />;
            default:
                return null;
        }
    };

    return (
        <div className="innocode-breakpoint-layout-bg">
            <div className="innocode-breakpoint-content">
                <div className={styles.layout_container}>
                    <header className={styles.header} id="main-header">
                        <InnocodeButton enablePadding={false} onClick={goBack} designType={'assistive'} theme={'opacity'} iconOnly={true} icon={
                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m15 19-7-7 7-7" />
                            </svg>

                        }></InnocodeButton>
                    </header>
                    <div className={styles.content_wrapper}>{renderStep()}</div>
                    <>
                    </>
                </div>
            </div>
        </div>
    );
}

export default MfaPage;
